var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAtm = function SvgAtm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.921 4H3.634c-.815 0-1.476.671-1.476 1.5v14c0 .83.663 1.502 1.48 1.5l3.441-.008h9.842c1.405 0 2.587.003 3.44.006.818.002 1.481-.67 1.481-1.5V5.5c0-.828-.661-1.499-1.476-1.499zM6.341 14.995a.75.75 0 0 1-.738.75.75.75 0 0 1-.738-.75V9.997c0-.41.334-.75.738-.75a.75.75 0 0 1 .738.75zm5.659.5c-1.634 0-2.953-1.34-2.953-2.999S10.367 9.497 12 9.497s2.953 1.34 2.953 3c0 1.658-1.32 2.998-2.953 2.998m7.135-.5a.75.75 0 0 1-.738.75.75.75 0 0 1-.738-.75V9.997c0-.41.335-.75.738-.75a.75.75 0 0 1 .738.75z"
  })));
};
export default SvgAtm;